// The config module loads the appropriate configuration based on the URL being
// visited and attaches variables to the window scope.
import _ from 'lodash';

// Use the _shared as a base, but allow overriding in each environment
let _shared = require('./environments/_shared');
let configMap = {
  dev: _.extend({}, _shared, require('./environments/dev')),
  localhost: _.extend({}, _shared, require('./environments/localhost')),
  prod: _.extend({}, _shared, require('./environments/prod')),
};

let ENV;
switch (location.hostname) {
  case 'localhost':
    ENV = 'localhost';
    break;
  case 'dashboard.dev.boxcast.com':
    ENV = 'dev';
    break;
  default:
    ENV = 'prod';
}

// Throw variables on window
_.each(configMap[ENV], function (value, key) {
  let override = localStorage.getItem(key);
  if (override) {
    console.warn('Overriding', key, 'with', override, 'instead of', value);
    value = override;
  }
  window[key] = value;
});

export default ENV;



// WEBPACK FOOTER //
// ./app/config.js